<template>
    <div style="width: 100%;height: 100%">
        <div
            id="index__tips"
            ref="index__tips"
            class="index__tips mb-1"
            v-html="indexObj.tips"
        />
        <div class="index__video-panel">
            <!-- 显示摄像头拍摄到的视频 -->
            <video id="index__video" class="index__video" ref="video" preload autoplay loop muted/>
            <!-- 视频上的提示框 -->
            <svg
                width="180"
                height="180"
                id="index__svg"
                class="index__video-over"
                ref="svg"
            >
                <polyline
                    points="5,50 5,5 50,5"
                    fill-opacity="0"
                    class="index_polyline"
                />
                <polyline
                    points="5,130 5,175 50,175"
                    fill-opacity="0"
                    class="index_polyline"
                />
                <polyline
                    points="135,5 175,5 175,45"
                    fill-opacity="0"
                    class="index_polyline"
                />
                <polyline
                    points="135,175 175,175 175,135"
                    fill-opacity="0"
                    class="index_polyline"
                />
            </svg>
            <canvas id="tracking__canvas" class="tracking__canvas-over"/>
        </div>
        <!-- 用于给video标签截图的画布 -->
        <canvas id="index__canvas" class="index__canvas-over" ref="canvas"/>
    </div>
</template>

<script>


require('tracking/build/tracking-min.js')
require('tracking/build/data/face-min.js')

export default {
    name: "FaceCamera",
    data() {
        return {
            indexObj: {tips: "请选择下工类型，然后摄像头会自动打开。"},
            userMedia: null,
            camera: null,
            imageInterval: null,
            successImage: "",
            userName: "",
            userId: "",
            trackingTask: null,
        };
    },
    created() {
        console.log("我被打开了");
        // this.userMedia =
        //   navigator.getUserMedia ||
        //   navigator.webkitGetUserMedia ||
        //   navigator.mozGetUserMedia;
        // this.openVideo();
        // this.clearCanvas();
    },
    mounted() {
        this.initVideo();
        this.id
    },
    beforeDestroy() {
        // clearInterval(this.imageInterval);
        this.closeVideo();
    },
    methods: {
        initVideo() {
            let canvas = document.getElementById("index__canvas");
            canvas.style.display = "none";
            let video = document.getElementById("index__video");
            video.style.display = "block";
            let svg = document.getElementById("index__svg");
            svg.style.display = "block";
            this.indexObj.tips = "请将面部对准镜头中央";
        },

        openVideo() {
            const g = this;
            this.userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia
                || navigator.mozGetUserMedia;
            if (g.userMedia) {
                navigator.getUserMedia(
                    {video: {width: 200, height: 200}},
                    function (stream) {
                        g.camera = stream.getTracks()[0];
                        const video = document.getElementById("index__video");
                        video.srcObject = stream;

                        let flag = true;

                        let canvas = document.getElementById("index__canvas");
                        let svg = document.getElementById("index__svg");

                        const trackingCanvas = document.getElementById('tracking__canvas');
                        const context = trackingCanvas.getContext('2d');

                        var tracker = new tracking.ObjectTracker('face');
                        tracker.setInitialScale(4);
                        tracker.setStepSize(2);
                        tracker.setEdgesDensity(0.1);

                        g.trackingTask = tracking.track('#index__video', tracker, {camera: true});

                        tracker.on('track', function (event) {

                            context.clearRect(0, 0, trackingCanvas.width, trackingCanvas.height);

                            event.data.forEach(function (rect) {
                                context.strokeStyle = "#a93df2";
                                context.strokeRect(rect.x - 10, rect.y - 10, rect.width * 1.3, rect.height);

                            });

                            if (flag && event.data.length) {
                                console.log("get face");
                                flag = false;
                                if (video.videoWidth === 0) {
                                    return;
                                }
                                // 让canvas和视频一样宽高。
                                let w = video.videoWidth;
                                let h = video.videoHeight;
                                canvas.width = w;
                                canvas.height = h;
                                // 把video标签中的画面，画到canvas中。
                                let ctx = canvas.getContext("2d");
                                ctx.drawImage(video, 0, 0, w, h);
                                // 把canvas中的图像转换成png图片文件的Base64字符串。
                                let imgStr = canvas.toDataURL("image/png").split("base64,")[1];

                                g.$store.dispatch("api/post",
                                    {
                                        url: g.$store.state.emAclUser.baseModuleUrl +
                                            "/emAclUser/currentFaceUser",
                                        data: imgStr
                                    },
                                    {root: true}
                                ).then(data => {
                                    let checkName = data.data.name;
                                    if (checkName !== null &&
                                        checkName !== undefined &&
                                        checkName !== "") {
                                        console.log("find user:" + checkName);
                                        g.closeVideo();
                                        canvas.style.display = "block";
                                        video.style.display = "none";
                                        svg.style.display = "none";
                                        trackingCanvas.style.display = "none";
                                        g.userName = checkName;
                                        g.userId = data.data.id;
                                        g.indexObj.tips = "当前用户:" + checkName;
                                        g.$emit('user-identified', g.userId);
                                    } else {
                                        g.indexObj.tips = data.data;
                                        setTimeout(function () {
                                            console.log("sleep 2s");
                                            flag = true;
                                        }, 2000);
                                    }
                                });
                            }
                        });
                    },
                    function (err) {
                        console.log("The following error occurred: " + err.name);
                        // eslint-disable-next-line no-undef
                        document.getElementById("index__tips").innerHTML = indexObj.tips;
                        g.camera.stop();
                    }
                );
                // eslint-disable-next-line no-empty
            } else {
            }
            console.log("摄像头打开");
        },
        closeVideo() {
            if (this.trackingTask) {
                this.trackingTask.stop();
            }
            if (this.camera) {
                console.log("closeVideo");
                this.camera.stop();
                // this.camera = null;
            }
            window.mediaStreamTrack && window.mediaStreamTrack.stop();
            console.log("摄像头关闭");
            // clearInterval(this.imageInterval);
        },
        // 继续检测人脸
        continueDraw() {
            const g = this;
            g.openVideo();
        },
        setTips(str) {
            const g = this;
            g.indexObj.tips = str;
        }
    }
};
</script>

<style scoped>
.index__tips {
    width: 100%;
    color: red;
    font-size: 16px;
    text-align: center;
    margin-top: -30px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    z-index: 9999;
}

.index__title {
    font-size: 20px;
    margin: 0 auto;
    width: auto;
    text-align: center;
    padding: 10px 0 15px 0;
}

.index__video-panel {
    width: 200px;
    height: 200px;
    padding: 0;
    border: 0;
    z-index: 0;
    margin: 0 auto;
}

.index__video {
    width: 200px;
    height: 200px;
    /* position: relative; */
    z-index: 0;
    /* float:left; */
}

.index__video-over {
    /* float:left; */
    position: relative;
    z-index: 1;
    margin: -190px 0 0 10px;
}

.index__video-over-button {
    position: relative;
    z-index: 1;
    color: white;
    background-color: #002fa7;
    width: 100px;
    height: 30px;
    line-height: 30px;
    margin: -40px 0 0 175px;
    text-align: center;
    cursor: pointer;
}

.index_polyline {
    stroke: #2387aa;
    stroke-width: 5;
}

.index__canvas-over {
    margin: -200px auto auto;
}

.tracking__canvas-over {
    width: 200px;
    height: 200px;
    margin: -220px 0 30px 40px;
    z-index: 99;
}
</style>
